jQuery(document).ready(function () {

    $(document).on('change', '.dnJs-checkboxClassSwitch', function (e) {
        var checkbox = $(this);

        var container = checkbox.attr('data-container');
        var className = checkbox.attr('data-class');
        var classMethod = checkbox.attr('data-class-method');

        if (checkbox.is(':checked')) {
            if (classMethod == 'remove') {
                $(container).removeClass(className);
            } else {
                $(container).addClass(className);
            }
        } else {
            if (classMethod == 'remove') {
                $(container).addClass(className);
            } else {
                $(container).removeClass(className);
            }
        }
    });
});